import * as React from 'react';
import { SVGProps } from 'react';
const SvgCollapse = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.1266 12.0982L15.3375 17.4499C15.3869 17.5139 15.4645 17.55 15.5453 17.55H16.8202C16.9307 17.55 16.9918 17.4237 16.9241 17.3384L12.5467 11.775L16.9241 6.21164C16.9394 6.1923 16.9488 6.16908 16.9514 6.14465C16.954 6.12021 16.9496 6.09555 16.9388 6.07347C16.9279 6.05139 16.9111 6.03279 16.8901 6.0198C16.8692 6.00681 16.8449 5.99995 16.8202 6H15.5453C15.4645 6 15.3869 6.03773 15.3375 6.10008L11.1266 11.4502C10.9765 11.6421 10.9765 11.9079 11.1266 12.0982ZM6.11257 12.0982L10.3234 17.4499C10.3729 17.5139 10.4504 17.55 10.5312 17.55H11.8062C11.9167 17.55 11.9777 17.4237 11.9101 17.3384L7.53267 11.775L11.9101 6.21164C11.9253 6.1923 11.9348 6.16908 11.9373 6.14465C11.9399 6.12021 11.9356 6.09555 11.9247 6.07347C11.9139 6.05139 11.897 6.03279 11.8761 6.0198C11.8551 6.00681 11.8309 5.99995 11.8062 6H10.5312C10.4504 6 10.3729 6.03773 10.3234 6.10008L6.11257 11.4502C5.96248 11.6421 5.96248 11.9079 6.11257 12.0982Z"
      fill="current"
    />
  </svg>
);
export default SvgCollapse;
